const NumberInput = {
  parts: ['field'],
  baseStyle: {
    field: {},
  },
  variants: {
    outline: {
      field: {
        borderRadius: 'sm',
        borderColor: 'gray.200',
      },
    },
  },
  defaultProps: {
    size: 'md',
    variant: 'outline',
  },
};

export default NumberInput;
